import { epoch, utc } from '../../util/datetime';
import { TimeUnitType } from '../global/TimeUnit.enum';
import type { ITicketValues } from './TicketValues.interface';

export default class TicketValues implements ITicketValues {
  currency: any;
  onceOff: number;
  onceOffDueDate: number;
  financeDueDate: number;
  recurring: number;
  recurringInterval: TimeUnitType;
  recurringStart: number;
  recurringEnd: number;

  static build = (data: ITicketValues) => new TicketValues(data);
  static blank = () => new TicketValues();

  /**
   * Constructor
   * @param {ITicketValues} data
   */
  constructor(data?: ITicketValues) {
    this.currency = data?.currency || undefined;
    this.onceOff = parseFloat(data?.onceOff || 0);
    this.onceOffDueDate = data?.onceOffDueDate ? epoch(utc(data?.onceOffDueDate)) : 0;
    this.financeDueDate = data?.financeDueDate ? epoch(utc(data?.financeDueDate)) : 0;
    this.recurring = parseInt(data?.recurring || 0, 10);
    // TODO: data?.recurringInterval is legacy data structure
    this.recurringInterval = TimeUnitType.of(
      data?.recurringInterval?.name || data?.recurringInterval
    );
    // TODO: data?.recurringInterval is legacy data structure
    this.recurringStart = data?.recurringStart ? epoch(utc(data?.recurringStart)) : 0;
    this.recurringEnd = data?.recurringEnd ? epoch(utc(data?.recurringEnd)) : 0;
  }
}
